export const iconFontAwesomeCampingFireFlameCurved = (
	<i className="fa-solid fa-fire-flame-curved"></i>
);
